import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Form } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { getResetPasswordTokenAction } from '../../actions/usersActions';
//Función principal
const RecoverForm = () => {
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store
    const usersLoading = useSelector(state => state.users.loading);
    //Inicializo el state local
    const [ user, setUser ] = useState({
        email: ''
    });
    //Manejo el submit
    const handleSave = values => {
        //Armo la data
        const data = {
            email: values.email
        }
        //Llamo al dispatch
        dispatch( getResetPasswordTokenAction(data) );
    }
    //Esquema de validación
    const validationSchema = yup.object({
        email: yup.string().email().required()
    });
    //Renderizo
    return (
        <React.Fragment>
            <div className="text-center">
                <h1 className="h4 text-gray-900 mb-2">Olvidó su contraseña?</h1>
                <p className="mb-4">
                    Ingrese a continuación la dirección de mail con la que se registró y le enviaremos un enlace para resetear su contraseña.
                </p>
            </div>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...user }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate className="user" onSubmit={handleSubmit} autoComplete="off">
                        <div className="form-group">
                            <Form.Control
                                id="email"
                                className="form-control form-control-user"
                                autoFocus
                                name="email" 
                                type="email" 
                                value={ values.email }
                                onChange={handleChange}
                                // ref={refApellido}
                                isInvalid={!!errors.email}
                                disabled={ usersLoading }
                                placeholder="Ingrese su email..."
                            />
                            <Form.Control.Feedback type="invalid">
                                { errors.email }
                            </Form.Control.Feedback>
                        </div>
                        <Button type="submit" variant="primary" className="btn-user btn-block">
                            Resetear contraseña
                        </Button>
                    </form>
                )}
            </Formik>
            <hr />
            <div className="text-center">
                <Link className="small" to="/iniciar-sesion">
                    Recordó su contraseña? Inicie sesión
                </Link>
            </div>
        </React.Fragment>
    );
};

export default RecoverForm;